"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var styledSystem_1 = require("../../styledSystem");
var utilities_1 = require("../../util/utilities");
var gapStyles = function (gap) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    gap: ", "", ";\n  "], ["\n    gap: ", "", ";\n  "])), gap, (0, utilities_1.setPxSuffix)(gap));
};
exports.Flex = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  box-sizing: border-box;\n  min-width: 0;\n\n  cursor: ", ";\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  box-sizing: border-box;\n  min-width: 0;\n\n  cursor: ", ";\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n"])), function (p) { return (p.onClick ? "pointer" : "unset"); }, function (_a) {
    var gap = _a.gap;
    return gap && gapStyles(gap);
}, styledSystem_1.flexbox, styledSystem_1.space, styledSystem_1.layout);
var templateObject_1, templateObject_2;
